module.exports = __webpack_public_path__ + "img/disponible-en-google-play-badge.6bb864c3.png";